import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { ProductTable, Product } from '../components/ProductTable';
import { TemplateSelectionModal } from '../components/TemplateSelectionModal';
import { Plus, Search, Filter } from 'lucide-react';
import { Input } from '../components/ui/Input';
interface ProductListProps {
  onNavigateToForm: (templateId: string | null) => void;
}
export function ProductList({
  onNavigateToForm
}: ProductListProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Mock Data
  const products: Product[] = [{
    id: '1',
    code: 'PL-001',
    name: 'Personal Loan Standard',
    status: 'active',
    category: 'Personal',
    lastUpdated: '2023-10-15'
  }, {
    id: '2',
    code: 'HL-002',
    name: 'Home Loan Variable',
    status: 'active',
    category: 'Mortgage',
    lastUpdated: '2023-09-22'
  }, {
    id: '3',
    code: 'AL-003',
    name: 'Auto Loan Premium',
    status: 'inactive',
    category: 'Auto',
    lastUpdated: '2023-08-10'
  }, {
    id: '4',
    code: 'BL-004',
    name: 'Business Term Loan',
    status: 'active',
    category: 'Business',
    lastUpdated: '2023-11-01'
  }, {
    id: '5',
    code: 'ED-005',
    name: 'Student Education Loan',
    status: 'active',
    category: 'Education',
    lastUpdated: '2023-10-05'
  }];
  const filteredProducts = products.filter(p => p.name.toLowerCase().includes(searchQuery.toLowerCase()) || p.code.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleCreateNew = () => {
    setIsModalOpen(true);
  };
  const handleTemplateSelect = (templateId: string | null) => {
    setIsModalOpen(false);
    onNavigateToForm(templateId);
  };
  return <div className="min-h-screen bg-gray-50/50 p-8" data-id="element-2211">
      <div className="max-w-7xl mx-auto space-y-8" data-id="element-2212">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2213">
          <div data-id="element-2214">
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2215">
              Loan Products
            </h1>
            <p className="text-gray-500 mt-1" data-id="element-2216">
              Manage and configure your lending product portfolio.
            </p>
          </div>
          <Button onClick={handleCreateNew} size="lg" className="shadow-sm" data-id="element-2217">
            <Plus className="mr-2 h-5 w-5" data-id="element-2218" />
            Add New Product
          </Button>
        </div>

        {/* Filters & Search */}
        <div className="flex flex-col sm:flex-row gap-4 bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-2219">
          <div className="relative flex-1" data-id="element-2220">
            <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2221" />
            <Input placeholder="Search products by name or code..." className="pl-10 border-0 bg-gray-50 focus:bg-white transition-colors" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2222" />
          </div>
          <Button variant="secondary" className="sm:w-auto" data-id="element-2223">
            <Filter className="mr-2 h-4 w-4" data-id="element-2224" />
            Filters
          </Button>
        </div>

        {/* Table */}
        <ProductTable products={filteredProducts} onProductClick={product => console.log('Clicked product:', product)} data-id="element-2225" />
      </div>

      <TemplateSelectionModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSelectTemplate={handleTemplateSelect} data-id="element-2226" />
    </div>;
}